// extracted by mini-css-extract-plugin
export default {"header":"header_header__sNvBo","title":"header_title__aY+RD"};